export class Validation {
    ID: number;
    Inactive: boolean;
}

export default Validation;